define('plugin/client-field/ClientFieldPlugin',['require','lib/plugin/PluginAbstract','plugin/client-field/view/ClientFieldsView','plugin/client-field/collection/ClientFieldsCollection','plugin/client-field/validator/ValidatorClientFields'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var ClientFieldsView = require('plugin/client-field/view/ClientFieldsView');
    var ClientFieldsCollection = require('plugin/client-field/collection/ClientFieldsCollection');
    var ValidatorClientFields = require('plugin/client-field/validator/ValidatorClientFields');
    
    return PluginAbstract.extend({
        
        initialize: function () {
            this._fieldsCollection = new ClientFieldsCollection();
            this.listenTo(this._fieldsCollection, 'sync', function () {
                if (this.view && !this.view.isDestroyed) {
                    this.view.render();
                }
            })
            this._fieldsCollection.fetch();
            
            Backbone.Wreqr.radio.channel('page').vent.on(
                'render', _.bind(this._addToClientView, this)
            );
            Backbone.Wreqr.radio.channel('client_login').vent.on(
                'client:signin', _.bind(this._reloadFieldsCollection, this)
            );
            Backbone.Wreqr.radio.channel('client_login').vent.on(
                'client:signout', _.bind(this._reloadFieldsCollection, this)
            );
            Backbone.Wreqr.radio.channel('client_login').vent.on(
                'client:idchanged', _.bind(this._reloadFieldsCollection, this)
            );
        },

        initStepManagerEvents: function () {
            this.listenTo(this._stepManager, 'step:render:client_login', this._addViewToClientLogin);
            //TODO details step, if client_login plugin not enabled
        },
        
        _addToClientView: function (data) {
            if (data.page == 'client_profile') {
                this._addView(data.view.model, data.view);
                
                var clientModel = data.view.model;
                if (clientModel.validators.client_fields === undefined) {
                    var fieldsCollection = this._fieldsCollection;
                    clientModel.validators.client_fields = [new ValidatorClientFields({
                        fields_collection: fieldsCollection,
                        model: clientModel
                    })];
                }
            } else if (data.page == 'client_login') {
                var clientModel = data.client_model;
                
                if (clientModel) {
                    if (clientModel.validators.client_fields === undefined) {
                        var fieldsCollection = this._fieldsCollection;
                        clientModel.validators.client_fields = [new ValidatorClientFields({
                            fields_collection: fieldsCollection,
                            model: clientModel
                        })];
                    }
                    
                    this._addView(clientModel, data.view);
                } 
            }
        },
        
        _addViewToClientLogin: function (step, layout) {
            //NB removed this code, since it is now added throgh "radio"
            // var clientModel = step.getClientModel();
            // 
            // if (clientModel.validators.client_fields === undefined) {
            //     var fieldsCollection = this._fieldsCollection;
            //     clientModel.validators.client_fields = [new ValidatorClientFields({
            //         fields_collection: fieldsCollection,
            //         model: clientModel
            //     })];
            // }
            // 
            // this._addView(clientModel, layout);
        },
        
        _addView: function (clientModel, layout) {
            if (!layout.client_fields) {
                layout.addRegion('client_fields', {
                    'selector': '.sb-client-fields',
                    'allowMissingEl': true
                });
            }
            
            var view = this.view = new ClientFieldsView({
                clientModel: clientModel,
                collection: this._fieldsCollection
            });
            
            layout.hideBuiltInFields();
            if (!layout._clientFieldProfileDataPatched) {
                var oldGetProfileData = layout.getProfileData;
                if (oldGetProfileData) {
                    layout.getProfileData = function () {
                        var data = oldGetProfileData.apply(this);
                        
                        _.extend(data, clientModel.pick(
                            'name', 'email', 'phone', 'password', 'with_address', 
                            'country_id', 'state_id', 'address1', 'address2', 'zip', 'city'
                        ));
                        
                        return data;
                    }
                }
                var oldGetDataToSignUp = layout.getDataToSignUp;
                if (oldGetDataToSignUp) {
                    layout.getDataToSignUp = function () {
                        var data = oldGetDataToSignUp.apply(this);
                        
                        _.extend(data, clientModel.pick(
                            'name', 'email', 'phone', 'password', 'with_address', 
                            'country_id', 'state_id', 'address1', 'address2', 'zip', 'city'
                        ));
                        
                        return data;
                    }
                }
                layout._clientFieldProfileDataPatched = true;
            }
            layout.showChildView('client_fields', view);
        },
        
        _reloadFieldsCollection: function () {
            this._fieldsCollection.fetch({reset: true});
        }

    });

});
